let instance;
let semaphore = false; // https://en.wikipedia.org/wiki/Semaphore_(programming)
import { globals } from '../utils';
import { getDrmType } from './drmConfiguration';
export async function getInstance() {
    if (!instance && !semaphore) {
        const Orchestra = await import(
        /* webpackChunkName: "orchestra" */
        '@amzn/Orchestrajs');
        instance =
            instance || new Orchestra.Player({
                version: 1,
                appVersion: globals.amznMusic.appConfig.version,
                appName: 'WebCP',
                hostname: globals.location.hostname +
                    (globals.location.port ? `:${globals.location.port}` : ''),
                musicTerritory: globals.amznMusic.appConfig.musicTerritory,
                clientId: 'WebCP',
                customerId: Date.now(),
                deviceTypeId: Date.now(),
                deviceId: Date.now(),
                tier: globals.amznMusic.appConfig.tier,
                flags: {
                    metrics: false,
                    drm: true,
                    broadcast: window.opener && true,
                },
                crossDomain: true,
                withCredentials: true,
                csrf: globals.amznMusic.appConfig.csrf
            });
    }
    semaphore = true;
    return instance;
}
let isEMESupportedPromise;
export async function isEMESupported() {
    var _a, _b, _c;
    if (!isEMESupportedPromise) {
        const Orchestra = await import(/* webpackChunkName: "orchestra" */ '@amzn/Orchestrajs');
        const result = (_a = Orchestra) === null || _a === void 0 ? void 0 : _a.Player.isEMESupported();
        const { UAParser } = await import(/* webpackChunkName: "metrics" */ 'ua-parser-js');
        const ua = new UAParser(globals.navigator.userAgent);
        const browser = ua.getBrowser();
        const os = ua.getOS();
        if (os.name === 'iOS') {
            return Promise.reject();
        }
        if (browser.name === 'Safari') {
            return ((_b = Orchestra) === null || _b === void 0 ? void 0 : _b.Player.isSupported('audio/mp4; codecs="mp4a.40.2"')) ? Promise.resolve()
                : Promise.reject();
        }
        const browserConf = getDrmType(browser.name, browser.major, os.name);
        if (browserConf) {
            return isEMESupportedPromise = isEMESupportedPromise || ((_c = Orchestra) === null || _c === void 0 ? void 0 : _c.Player.isEMESupported(browserConf.keySystem, browserConf.supportedConfiguration));
        }
        isEMESupportedPromise = result ? Promise.resolve() : Promise.reject();
    }
    return isEMESupportedPromise;
}
export function setPlayerConfig(playerInst, auth) {
    playerInst.setConfig({
        customerId: `${auth.customerId}`,
        oAuthToken: `${auth.accessToken}`,
        deviceId: `${auth.deviceId}`,
        deviceTypeId: `${auth.deviceType}`,
        csrf: auth.csrf,
        ipAddress: `${globals.amznMusic.appConfig.ipAddress}`,
    });
    const volume = globals.localStorage.getItem(`${auth.deviceId}_volume`);
    if (volume !== null) {
        playerInst.volume(+volume);
    }
}
window.maestro = {
    getInstance,
    isEMESupported,
    setPlayerConfig,
};
